import React from 'react';
import { Divider, Modal, Icon } from 'antd';
import Context from '../../layout/Container/Context';
import { asserts } from '../../../utils';
import './index.less';

export default ({ data }) => {
  const [visible, setViisible] = React.useState(false);
  const { history } = React.useContext(Context);
  React.useEffect(() => {
    setViisible(true);
  }, []);

  const handleClose = () => {
    setViisible(false);
  };

  const handleCheck = () => {
    history.push('/profile/memberInfo');
  };

  return (
    <>
      <Modal
        visible={visible}
        width={700}
        footer={null}
        wrapClassName="memberUp-modal"
        maskClosable={false}
        centered={true}
        onCancel={handleClose}
        closable={false}
      >
        <div className="wrapper-content">
          <div
            className="wrapper-img"
            style={{
              background: `url('${process.env.TARGET}static/imgs/member/bg.png') center center no-repeat`,
              backgroundSize: 'cover',
            }}
          >
            <div className="modal-content">
              <p className="member-tip">
                恭喜您<span className="text-red">升级</span>成为
              </p>
              <p className="member-name" style={{ fontWeight: 'bold' }}>
                <span>{data.levelName}</span>
                {asserts.isExist(data.smallLevel) && Object.keys(data.smallLevel).length ? (
                  <span>{data.smallLevel.lvName}</span>
                ) : null}
              </p>
              <Divider className="equity-divider">您将享受如下特权</Divider>
              <div className="equity-content">
                {data.equities.map((item, index) => {
                  return (
                    <div
                      className="equity-item"
                      key={index}
                      style={{ width: `calc(100% / ${data.equities.length})` }}
                    >
                      <div
                        className="item-circle-bg"
                        style={{
                          background: `url('${process.env.TARGET}static/imgs/member/enquityBg.svg') center center no-repeat`,
                          backgroundSize: 'cover',
                        }}
                      >
                        <img
                          src={`${process.env.ASSETS}/${item.picAddr}`}
                          alt=""
                          width={20}
                          height={20}
                        />
                      </div>
                      <p className="equity-name">{item.equityCode}</p>
                    </div>
                  );
                })}
              </div>
              <div className="equity-btn pointer">
                <span onClick={() => handleCheck()}>查看详细权益</span>
              </div>
              <p className="equity-tip">升级下月生效。最终解释权归东明所有</p>
            </div>
            <div className="close-icon" onClick={handleClose}>
              <img
                src={`${process.env.TARGET}static/imgs/member/closeIcon.svg`}
                alt=""
                width={40}
                height={40}
              />
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
